import styled from 'styled-components';

import { dateFormatter, hourMinuteFormatter, Translate, useInterpolatedTranslationKey } from '@dreryk/react-common';
import { basicSmallTextStyle, Text } from '@dreryk/react-components';

import { visitSettlementTranslationKeys } from '../../translations';

const t = visitSettlementTranslationKeys.shared.adjustment.dataText;

export const StyledAdjustmentDataText = styled(Text)`
   ${basicSmallTextStyle};
   color: ${(props) => props.theme.placeholder};
`;

StyledAdjustmentDataText.displayName = 'StyledAdjustmentDataText';

type AdjustmentDataTextProps = {
   readonly date: Date;
   readonly author: string;
};

export const AdjustmentDataText = (props: AdjustmentDataTextProps): JSX.Element => {
   return (
      <StyledAdjustmentDataText testId={'adjustmentData'}>
         <Translate>
            {useInterpolatedTranslationKey(t.label, {
               author: props.author,
               date: dateFormatter(props.date),
               time: hourMinuteFormatter(props.date),
            })}
         </Translate>
      </StyledAdjustmentDataText>
   );
};
